import { createReducer, on } from '@ngrx/store';
import { HOLIDAY_ACTIONS } from '../actions/holiday.action';
import { HolidaysState } from '../type/holiday.type';

export const initialState: HolidaysState = {
  error: null,
  holidays: null,
  loading: false,
};

export const HOLIDAYSREDUCER = createReducer(
  initialState,
  on(HOLIDAY_ACTIONS.loadHolidays, (state) => ({
    ...state,
    loading: true,
  })),
  on(HOLIDAY_ACTIONS.loadHolidaysSuccess, (state, { holidays }) => ({
    ...state,
    holidays,
    loading: false,
  })),
  on(HOLIDAY_ACTIONS.loadHolidaysFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),
);
